import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        'navigation-drawer': '#FFFFFF',
        background: '#f2f5f8',
        toolbar: '#FFFFFF',
        sheet: '#FAFAFA',
        primary: '#2a4f66',
        secondary: '#5CBBF6',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        'navigation-drawer': '#13141f',
        background: '#13141f',
        toolbar: '#13141f',
        sheet: '#171723',
        primary: '#5c7f94',
        secondary: '#6a8c65',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
});
